import * as types from "./mutation-types";
import { categoria_empty } from "./getters";
import { merge } from "lodash";

export default {
  [types.SET_CATEGORIAS](state, payload) {
    state.categorias = payload;
  },
  [types.SET_CATEGORIA](state, payload) {
    payload = merge(categoria_empty(), payload);
    state.categoria = payload;
  },
  [types.SET_PAGINATION](state, payload) {
    state.pagination = payload;
  }
};
